import { useBodyPointerEventsGuard } from "@/hooks/useBodyPointerEventsGuard";

export default function BodyPointerEventsGuard() {
  useBodyPointerEventsGuard();
  return null;
}
